// extracted by mini-css-extract-plugin
module.exports = {"representative-example":"RepresentativeExample_representative-example__ENe6T","representative-example__bullet":"RepresentativeExample_representative-example__bullet__gpEc6"};